import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import TextField from 'material-ui/TextField';

import { searchLoaded, searchLoading } from './components/Search/searchActions';
import API from "./api/ApiTool";

const barStyles = {
  wrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  logo: {
    fontSize: '13px',
    fontWeight: 300,
    letterSpacing: '0.35em',
    color: '#1f2024',
    fontFamily: '"Inter", system-ui, sans-serif',
    textTransform: 'uppercase',
    userSelect: 'none',
  },
  logoAccent: {
    color: '#2563eb',
    fontWeight: 500,
  },
  searchWrap: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  searchIcon: {
    position: 'absolute',
    left: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#8a8e98',
    fontSize: '14px',
    pointerEvents: 'none',
  },
};

class AppBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
    };
  }

  setInput(e, value) {
    this.setState({search: value})
  }

  search() {
    this.props.searchLoading();

    API.POST(`/reporting/search/`, {'query': this.state.search})    
      .then(response => response.json())
      .then(this.props.searchLoaded)
      .then(this.props.history.push('/search-results'))
  }

  render() {
    return (
      <div style={barStyles.wrap}>
        <span style={barStyles.logo}>
          <span style={barStyles.logoAccent}>B B L</span>
          {'  '}R E P O R T I N G
        </span>
        <span style={barStyles.searchWrap}>
          <span style={barStyles.searchIcon}>&#x1F50D;</span>
          <TextField
            hintText="Search companies, numbers..."
            hintStyle={{
              color: '#8a8e98',
              fontSize: '13px',
              fontFamily: '"Inter", system-ui, sans-serif',
              paddingLeft: '28px',
            }}
            inputStyle={{
              color: '#1f2024',
              fontSize: '13px',
              fontFamily: '"Inter", system-ui, sans-serif',
              paddingLeft: '28px',
            }}
            underlineStyle={{borderColor: '#d8d6cc'}}
            underlineFocusStyle={{borderColor: '#2563eb'}}
            style={{width: '240px'}}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                this.search();
            }}}
            onChange={this.setInput.bind(this)}
          />
        </span>
      </div>
    );
  }
}

const enhance = connect(null, {
    searchLoaded: searchLoaded,
    searchLoading: searchLoading
})(AppBar);

export default withRouter(enhance);



// WEBPACK FOOTER //
// ./src/AppBar.js